import { cn } from '@/lib/utils'
import { CO_TAX_CREDIT } from '@/lib/constants'

interface TicketStubProps {
  amount?: string
  subtitle?: string
  location?: string
  voucherNumber?: string
  expiresAt?: string
  redeemed?: boolean
  className?: string
}

export function TicketStub({
  // SOURCE: lib/constants.ts (CO_TAX_CREDIT) — 2026 Colorado e-bike credit.
  amount = `$${CO_TAX_CREDIT}`,
  subtitle = "Cash back on qualifying ebikes",
  location = "Boulder, CO",
  voucherNumber,
  expiresAt = "exp. 12/31/26",
  redeemed = true,
  className,
}: TicketStubProps) {
  const displayNumber = voucherNumber ?? "2026-02250"

  return (
    <div className={cn("relative", className)}>
      {/* ticket body */}
      <div
        className={cn(
          "relative bg-secondary rounded-[14px] px-9 py-8",
          "border-2 border-[rgba(0,40,104,0.18)]",
          "shadow-lg"
        )}
      >
        {/* perforation line */}
        <div
          aria-hidden="true"
          className="absolute left-0 right-0 border-t-2 border-dashed border-[rgba(0,40,104,0.35)]"
          style={{ top: "62%" }}
        />

        {/* header row */}
        <div className="flex justify-between items-start mb-4 gap-4">
          <div className="min-w-0">
            <div className="text-[10px] text-primary tracking-[0.12em] uppercase font-semibold whitespace-nowrap">
              State of Colorado
            </div>
            <div className="text-xs text-primary mt-0.5 opacity-75 whitespace-nowrap">
              eBike Tax Voucher · 2026
            </div>
          </div>
          <div className="font-mono text-[10px] text-primary opacity-60 text-right whitespace-nowrap shrink-0">
            Nº {displayNumber}<br />{expiresAt}
          </div>
        </div>

        {/* amount */}
        <div className="hand text-[120px] text-primary leading-[0.95] font-bold text-center">
          {amount}
        </div>

        {/* subtitle */}
        <div className="text-sm text-primary text-center mt-2 opacity-75">
          {subtitle}
        </div>

        {/* footer row */}
        <div className="mt-4 pt-4 flex justify-between items-center">
          <div className="text-[10px] text-primary tracking-[0.12em] uppercase font-semibold whitespace-nowrap">
            {location}
          </div>
          {redeemed && (
            <div className="hand text-xl text-accent -rotate-[4deg]">
              REDEEMED ✓
            </div>
          )}
        </div>
      </div>

      {/* shadow stack */}
      <div
        aria-hidden="true"
        className="absolute inset-0 rounded-[14px] -z-10 translate-x-2.5 translate-y-2.5 -rotate-3 bg-[rgba(0,40,104,0.12)]"
      />
    </div>
  )
}
